<template>
  <div ref="eaChartsRef03" style="height: 320px" />
</template>

<script>
import * as echarts from 'echarts';
import { debounce } from 'lodash-es';

export default {
  name: 'EaCharts03',
  props: {
    paramsData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      eaChartsRef03: null,
      resizeHandler: null,
      dtArr: [],
      shouldReturnNumArr: [],
      actualReturnNumArr: [],
      diffNumArr: [],
      labelTitle: [
        { name: '应退回票数Qtd. de recibos a devolver', icon: 'rect' },
        { name: '实际退回袋数Numero real de sacos devolvidos', icon: 'rect' }
      ]
    };
  },
  computed: {
    // 核心优化：根据 dataType 动态生成图例
    legendData() {
      if (this.paramsData.dataType === 'HUB1') {
        return [...this.labelTitle, { name: '差值Taxadefakedelivery', icon: 'rect' }];
      }
      return this.labelTitle;
    },
    options() {
      return {
        title: {
          text: '编织袋回收监控 Monitoramento da reciclagem de sacos de ráfia',
          left: 'left',
          textStyle: { color: '#333', fontSize: 14 }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: { type: 'shadow' },
          backgroundColor: 'rgba(255,255,255,0.9)',
          borderColor: '#ddd',
          borderWidth: 1,
          textStyle: { color: '#333', fontSize: 12 },
          formatter: (params) => {
            const dateName = params[0]?.name || '未知日期';
            let html = `<div style="padding: 4px; font-weight: 600; font-size: 12px;">${dateName}</div>`;
            params.forEach((item) => {
              const val = item.value === '-' ? '0' : item.value;
              html += `
                <p style="margin: 2px 0; display: flex; align-items: center; font-size: 12px;">
                  <span style="width: 8px; height: 8px; border-radius: 2px; background: ${item.color}; margin-right: 4px;"></span>
                  ${item.seriesName} <span style="margin-left: 8px; font-weight: 600;">${val}</span>
                </p>
              `;
            });
            return html;
          }
        },
        legend: {
          top: 25,
          left: 'center',
          data: this.legendData,
          textStyle: { color: '#333', fontSize: 10 },
          itemGap: 8,
          itemWidth: 8,
          itemHeight: 8
        },
        grid: {
          left: '8%',
          right: '8%',
          bottom: '20%',
          top: '20%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.dtArr,
          axisLine: { lineStyle: { color: '#666', width: 1 }},
          axisLabel: { color: '#333', fontSize: 10 },
          axisTick: { show: false }
        },
        yAxis: {
          type: 'value',
          axisLabel: { color: '#333', fontSize: 10 },
          splitLine: { lineStyle: { color: '#eee', type: 'dashed', width: 1 }},
          axisLine: { lineStyle: { color: '#666', width: 1 }}
        },
        dataZoom: [
          { type: 'inside', start: 20, end: 50 },
          {
            type: 'slider',
            start: 20,
            end: 50,
            maxSpan: 60, // 最大只能选60%宽度，不能拉满
            height: 20,
            bottom: 10,
            textStyle: { fontSize: 10, color: '#333' },
            handleSize: '80%',
            fillerColor: 'rgba(32, 201, 151, 0.2)',
            borderColor: '#ddd'
          }
        ],
        series: [
          {
            name: '应退回票数Qtd. de recibos a devolver',
            type: 'bar',
            barWidth: '40%',
            barMinWidth: 30,
            barMaxWidth: 40,
            itemStyle: { color: '#20c997' },
            label: { show: true, position: 'top', fontSize: 10, color: '#333', formatter: '{c}' },
            data: this.shouldReturnNumArr
          },
          {
            name: '实际退回袋数Numero real de sacos devolvidos',
            type: 'bar',
            barWidth: '40%',
            barMinWidth: 30,
            barMaxWidth: 40,
            itemStyle: { color: '#ffc107' },
            label: { show: true, position: 'top', fontSize: 10, color: '#333', formatter: '{c}' },
            data: this.actualReturnNumArr
          },
          {
            name: '差值Taxadefakedelivery',
            type: 'bar',
            barWidth: '40%',
            barMinWidth: 30,
            barMaxWidth: 40,
            itemStyle: { color: '#ff584c' },
            label: { show: true, position: 'top', fontSize: 10, color: '#333', formatter: '{c}' },
            data: this.diffNumArr
          }
        ]
      };
    }
  },
  // 核心：监听props变化，数据更新就重新渲染
  watch: {
    paramsData: {
      deep: true, // 监听对象深层变化
      handler() {
        this.$nextTick(() => {
          this.renderChart();
        });
      }
    }
  },
  mounted() {
    // 初始化resize监听
    this.resizeHandler = debounce(() => this.eaChartsRef03?.resize(), 100);
    window.addEventListener('resize', this.resizeHandler);
    // 首次渲染
    this.renderChart();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeHandler);
    this.eaChartsRef03?.dispose();
  },
  methods: {
    // 统一渲染逻辑（抽离出来，方便复用）
    renderChart() {
      // 1. 空值兜底：防止chartData不存在时报错
      const chartData = this.paramsData.chartData || [];
      // 2. 处理数据（判空转0）
      this.dtArr = chartData.map((item) => item.dt || '');
      this.shouldReturnNumArr = chartData.map((item) => item?.shouldReturnNum ?? '');
      this.actualReturnNumArr = chartData.map((item) => item?.actualReturnNum ?? '');
      if (this.paramsData.dataType === 'HUB1') {
        this.diffNumArr = chartData.map((item) => item?.diffNum ?? '');
      } else {
        this.diffNumArr = null;
      }

      console.log(this.paramsData, 'dataTypedataType');
      // 3. 初始化/更新图表
      if (!this.eaChartsRef03) {
        this.eaChartsRef03 = echarts.init(this.$refs.eaChartsRef03);
      }
      this.eaChartsRef03.setOption(this.options, true);
    }
  }
};
</script>
